// export const API_URL = 'http://192.168.15.2:3333';

export const API_URL = 'https://btcl.beyondtheclub.com.br:3333';